// @ts-check

import { dbPostWithFormData } from "utils/DBFetchers";

/** @typedef {{ data: Array<{ period: number, enrolled_pharmacies: number, active_pharmacies: number, new_pharmacies_with_sales: number }>, output_files: Record<string, string> }} IndependentPharmacyActivityResponse */

export const INDEPENDENT_PHARMACY_ACTIVITY_ENDPOINT =
  "cli/reporte_actividad_independientes";

/**
 * @param {number} fromPeriod
 * @param {number} toPeriod
 * @returns {Promise<IndependentPharmacyActivityResponse>}
 */
export async function getIndependentPharmacyActivity(fromPeriod, toPeriod) {
  const formData = new FormData();
  formData.append("from_period", String(fromPeriod));
  formData.append("to_period", String(toPeriod));
  const response = await dbPostWithFormData(
    INDEPENDENT_PHARMACY_ACTIVITY_ENDPOINT,
    formData,
  );

  return {
    data: Array.isArray(response?.report_data) ? response.report_data : [],
    output_files: response?.output_files || {},
  };
}
